import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import retourFournisseurService from "../services/retourFournisseurService";

const initialState = {
    retourFournisseur: [],
    newReturnNumber: null,
    loading: false,
    error: null
};

const retourFournisseurSlice = createModule({
    name: 'retourFournisseur',
    initialState,
    reducers: {
        list: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        filter: (state) => {
            state.loading = true;
        },
        getById: (state) => {
            state.loading = true;
        },
        create: (state) => {
            state.loading = true;
        },
        update: (state) => {
            state.loading = true;
        },
        generateNumero: (state) => {
            state.loading = true;
        },
        validate: (state) => {
            state.loading = true;
        },
        cancel: (state) => {
            state.loading = true;
        },
        delete: (state) => {
            state.loading = true;
        },
        generatePdf: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.retourFournisseur = payload.body || payload;
        },
        fetchedNumero: (state, payload) => {
            state.loading = false;
            state.newReturnNumber = payload;
        },
        fetchedSingle: (state, payload) => {
            state.loading = false;
            state.currentReturn = payload;
        },
        finishLoading: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "Une erreur s'est produite";
        },
    },
    sagas: (A) => ({
        *[A.list]({ payload = {} }) {
            try {
                const { data } = yield call(retourFournisseurService.list, payload);
                yield put(A.fetchedData(data));
            } catch (error) {
                console.error('Error fetching fournisseur returns:', error);
                yield put(A.fetchError(error.message));
            }
        },

        *[A.filter]({ payload }) {
            try {
                const { data } = yield call(retourFournisseurService.list, payload);
                yield put(A.fetchedData(data));
            } catch (error) {
                console.error('Error filtering customer returns:', error);
                yield put(A.fetchError(error.message));
            }
        },
        *[A.generateNumero]({ payload }) {
            try {
                const { data } = yield call(retourFournisseurService.generateNumero);
                yield put(A.fetchedNumero(data));
            } catch (error) {
                console.error('Error generating customer return number:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.getById]({ payload }) {
            try {
                const { data } = yield call(retourFournisseurService.getById, payload.id);
                yield put(A.fetchedSingle(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                console.error('Error fetching customer return:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.create]({ payload }) {
            try {
                const { data } = yield call(retourFournisseurService.create, payload.data);
                yield put(A.finishLoading());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                console.error('Error creating customer return:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.update]({ payload }) {
            try {
                const { data } = yield call(retourFournisseurService.update, payload.id, payload.data);
                yield put(A.finishLoading());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                console.error('Error updating customer return:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.validate]({ payload }) {
            try {
                const { data } = yield call(retourFournisseurService.validate, payload.id);
                yield put(A.finishLoading());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                console.error('Error validating customer return:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.cancel]({ payload }) {
            try {
                const { data } = yield call(retourFournisseurService.cancel, payload.id);
                yield put(A.finishLoading());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                console.error('Error cancelling customer return:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.delete]({ payload }) {
            try {
                yield call(retourFournisseurService.delete, payload.id);
                yield put(A.finishLoading());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess);
                }
            } catch (error) {
                console.error('Error deleting customer return:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.generatePdf]({ payload }) {
            try {
                const response = yield call(retourFournisseurService.generatePdf, payload.id);
                yield put(A.finishLoading());
                
                // Create blob and download
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `retour-client-${payload.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                if (payload.onSuccess) {
                    yield call(payload.onSuccess);
                }
            } catch (error) {
                console.error('Error generating PDF:', error);
                yield put(A.fetchError(error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
    }),
});

export const retourFournisseurActions = retourFournisseurSlice.actions;
export default retourFournisseurSlice;
